module.exports = "/_next/static/images/1e5e0215fbd69b49cd6e0efb698b881c-mulher-perfil-segurando-cartao-xs@1x.jpg.webp";